// TODO:
// 1. action icons
// 2. view location block

import React from 'react';
import dateformat from 'dateformat';

import {UPCOMING_KEY, CANCELLED_KEY, COMPLETED_KEY, FAILED_KEY} from '@ibibo/myaccount-reducer';

import * as S from './BkngDetailsBlock.styles';

import BookingDetailFullBlock from './BookingDetailFullBlock';
import BookingDetailSummaryBlock from './BookingDetailSummaryBlock';

import BkngActions from '../../../../common/BkngActions/BkngActions';

const BookingDetails = ({trip_type, data}) => {
  switch (trip_type.toLowerCase()) {
    case UPCOMING_KEY:
    case COMPLETED_KEY:
      return <BookingDetailFullBlock data={data} />;
    case CANCELLED_KEY:
    case FAILED_KEY:
      return <BookingDetailSummaryBlock data={data} />;
    default:
      return <BookingDetailFullBlock data={data} />;
  }
}

const BkngDetailsBlock = ({trip_type, bookingDetails}) => {
  const {actions, } = bookingDetails;

  return(
    <S.BkngDetailMainWrap>
      <S.BkngDetailOuterWrap>
        <BookingDetails trip_type={trip_type} data={bookingDetails} />
      </S.BkngDetailOuterWrap>
      <BkngActions actions={actions} />
    </S.BkngDetailMainWrap>
  );
}

export default  BkngDetailsBlock;